// KHD custom JS. Loaded as an ES module after Boost's theme.js via layout/theme.liquid.
// Keep all KHDStickers-specific behaviour in this file so Boost upstream files stay untouched.
// Each ported feature appends its own block below.

// --- Sidebar nav: submenu toggle + header height measurement ---
// Click delegate expands/collapses submenus in khd-sidebar-nav.
// The sidebar's top offset depends on the static header height; we measure
// it once on load + on resize and expose it as --khd-header-height so the
// CSS rule (top: var(--khd-header-height, 80px)) stays accurate.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.khd-sidebar__toggle');
  if (!toggle) return;

  const controlsId = toggle.getAttribute('aria-controls');
  if (!controlsId) return;

  const submenu = document.getElementById(controlsId);
  if (!submenu) return;

  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isExpanded));
  submenu.toggleAttribute('hidden', isExpanded);
});

// Header height is exposed as --khd-header-height for any KHD element that
// needs to align below the header (currently the sidebar; future features
// may use it too). Runs on every page, not just sidebar-enabled ones, so
// the variable is always available.
(() => {
  const updateHeaderHeight = () => {
    // Measure the outer .header-group wrapper (announcement bar + search +
    // nav rows), not just .site-header — Boost stacks multiple sub-rows.
    const headerGroup = document.querySelector('.header-group');
    if (!headerGroup) return;
    const height = headerGroup.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--khd-header-height', `${Math.round(height)}px`);
    }
  };

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  // Re-measure when fonts load (Boost loads custom fonts which can shift
  // header height after initial paint).
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeight);
  }
})();

// --- Back-to-Top button ---
// Injects a floating button that appears after scrolling past THRESHOLD px
// and smooth-scrolls to the top on click. No Liquid/HTML edits needed.
(() => {
  const THRESHOLD = 600;

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'khd-back-to-top';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="18 15 12 9 6 15"></polyline>' +
    '</svg>';

  btn.addEventListener('click', () => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
  });

  document.body.appendChild(btn);

  let ticking = false;
  const update = () => {
    btn.classList.toggle('khd-back-to-top--visible', window.scrollY > THRESHOLD);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();
